import { DEFAULT_CURRENCY } from '@shared/utils/currency/constants';
import type { SalesOrder } from './JoyPurchasedOrder.types';

export function calcSubtotal(salesOrder: SalesOrder) {
  // FIXME: shipWhatWeCan
  //   Compensation should be treated as Joy Credit, vs. mocked as a "real Item"
  const subtotal = (salesOrder?.subtotal?.valueInMinorUnits ?? 0) / 100;
  const compensationTotal = (salesOrder?.compensationTotal?.valueInMinorUnits ?? 0) / 100;

  return subtotal + compensationTotal;
}

export function deriveCurrencyCode(salesOrder: SalesOrder) {
  // this is obtuse
  return salesOrder?.subtotal?.currency?.code || DEFAULT_CURRENCY;
}
